import { InputfieldTypes } from "../../../enums/InputFieldAttributesEnums";
import { FilterOptionFieldType } from "../../../Types/ticketUploadTypes";
import { disableFutureDates } from "../../../utils/disabledDateUtil";
import type { SelectProps } from "antd";

export const ticketFilterConstants = {
  HEADER_TXT: "Filter",
  SUBMIT_BTN_TXT: "Apply",
  CANCEL_BTN_TXT: "Cancel",
  CLEAR_BTN_TXT: "Clear Filters",
  DRAWER_PLACEMENT: "right",
  DRAWER_SIZE: "large",
  DRAWER_WIDTH: "36rem",
  DRAWER_HEIGHT: "100vh",
  CANCEL_BTN_CLASS: "cancelFilterButton",
  SELECT_PLACEHOLDER: "Select",
  SEARCH_FILTER_PROP: "label",
};

export const filterFieldConstants = {
  CUSTOMER_FILTER_LABEL: "Customer",
  JOB_ID_FILTER_LABEL: "Job ID",
  ORDER_FILTER_LABEL: "Order",
  TRUCK_FILTER_LABEL: "Truck #",
  DATE_FILTER_LABEL: "Date",
  JOB_NAME_FILTER_LABEL: "Job Name",
  CUSTOMER_FILTER_NAME: "customerNameFilter",
  JOB_ID_FILTER_NAME: "jobIdFilter",
  ORDER_FILTER_NAME: "orderIdFilter",
  TRUCK_FILTER_NAME: "truckNumberFilter",
  DATE_FILTER_NAME: "dateRangeFilter",
  JOB_NAME_FILTER_NAME: "jobNameFilter",
};

export const filterFormMap = [
  {
    key: "companyIds",
    field: filterFieldConstants.CUSTOMER_FILTER_NAME,
  },
  {
    key: "truckIds",
    field: filterFieldConstants.TRUCK_FILTER_NAME,
  },
  {
    key: "orderIds",
    field: filterFieldConstants.ORDER_FILTER_NAME,
  },
  {
    key: "jobNames",
    field: filterFieldConstants.JOB_NAME_FILTER_NAME,
  },
  {
    key: "jobNumbers",
    field: filterFieldConstants.JOB_ID_FILTER_NAME,
  },
];

export const filterHeaderStyle = {
  backgroundColor: "#586370",
  padding: "1rem",
  color: "white",
};

export const getFilterOptionFields = (params: FilterOptionFieldType) => [
  {
    type: InputfieldTypes.MULTIPLE_SELECT_SEARCH,
    name: filterFieldConstants.CUSTOMER_FILTER_NAME,
    label: filterFieldConstants.CUSTOMER_FILTER_LABEL,
    bordered: true,
    placeholder: ticketFilterConstants.SELECT_PLACEHOLDER,
    showSearch: true,
    setSearch: params.setCustomerSearchValue,
    searchValue: params.customerSearchValue,
  },
  {
    type: InputfieldTypes.MULTIPLE_SELECT_SEARCH,
    name: filterFieldConstants.JOB_ID_FILTER_NAME,
    label: filterFieldConstants.JOB_ID_FILTER_LABEL,
    bordered: true,
    placeholder: ticketFilterConstants.SELECT_PLACEHOLDER,
    showSearch: true,
    setSearch: params.setJobIdSearchValue,
    searchValue: params.jobIdSearchValue,
  },
  {
    type: InputfieldTypes.MULTIPLE_SELECT_SEARCH,
    name: filterFieldConstants.ORDER_FILTER_NAME,
    label: filterFieldConstants.ORDER_FILTER_LABEL,
    bordered: true,
    placeholder: ticketFilterConstants.SELECT_PLACEHOLDER,
    showSearch: true,
    setSearch: params.setOrderSearchValue,
    searchValue: params.orderSearchValue,
  },
  {
    type: InputfieldTypes.MULTIPLE_SELECT_SEARCH,
    name: filterFieldConstants.TRUCK_FILTER_NAME,
    label: filterFieldConstants.TRUCK_FILTER_LABEL,
    bordered: true,
    placeholder: ticketFilterConstants.SELECT_PLACEHOLDER,
    showSearch: true,
    setSearch: params.setTruckSearchValue,
    searchValue: params.truckSearchValue,
  },
  {
    type: InputfieldTypes.RANGE_PICKER,
    name: filterFieldConstants.DATE_FILTER_NAME,
    label: filterFieldConstants.DATE_FILTER_LABEL,
    disabledDates: disableFutureDates,
    allowDateClear: true,
  },
  {
    type: InputfieldTypes.MULTIPLE_SELECT_SEARCH,
    name: filterFieldConstants.JOB_NAME_FILTER_NAME,
    label: filterFieldConstants.JOB_NAME_FILTER_LABEL,
    bordered: true,
    placeholder: ticketFilterConstants.SELECT_PLACEHOLDER,
    showSearch: true,
    setSearch: params.setJobNameSearchValue,
    searchValue: params.jobNameSearchValue,
  },
];
